import * as t from "io-ts";
import nullable from "./nullable";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
const settingsFieldsT = {
    enabled: t.boolean,
    sendConfirmation: t.boolean,
    cargoTagId: nullable(t.string),
    fallbackAddress: nullable(t.string),
    fallbackPostcode: nullable(t.string),
    fallbackCity: nullable(t.string),
    fallbackCountry: nullable(t.string),
};
export const updateMailOrderSettingsT = t.strict(settingsFieldsT);
export const mailOrderSettingsT = t.strict({
    ingestToken: t.string,
    ...settingsFieldsT,
});
export const mailOrderAttachmentT = t.strict({
    id: t.string,
    filename: t.string,
    contentType: t.string,
    sizeBytes: t.number,
    url: nullable(t.string),
});
export const mailOrderSourceT = t.strict({
    subject: nullable(t.string),
    fromAddress: nullable(t.string),
    fromName: nullable(t.string),
    receivedAt: isoDateTimeForJSON,
    text: nullable(t.string),
    orderIndex: t.number,
    attachments: t.array(mailOrderAttachmentT),
});
export const updateMailOrderTemplateResultT = t.strict({
    updated: t.boolean,
    reason: nullable(t.string),
});
export const mailOrderTemplateListItemT = t.strict({
    id: t.string,
    senderAddress: nullable(t.string),
    updatedAt: isoDateTimeForJSON,
});
export const mailOrderTemplateListT = t.array(mailOrderTemplateListItemT);
export const mailOrderTemplateDetailT = t.strict({
    id: t.string,
    senderAddress: nullable(t.string),
    exampleSource: t.string,
    exampleOutput: t.unknown,
    updatedAt: isoDateTimeForJSON,
});
//# sourceMappingURL=mail-orders.js.map